const loader = document.querySelector('[data-balance-loader]');
if (loader && !window.Shopify?.designMode) {
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  let showTimer, hideTimer, safetyTimer;
  const hide = (immediate = false) => {
    clearTimeout(showTimer);
    clearTimeout(hideTimer);
    clearTimeout(safetyTimer);
    if (loader.hidden) return;
    if (immediate || reduced.matches) loader.hidden = true;
    else {
      loader.classList.add('is-leaving');
      hideTimer = setTimeout(() => { loader.hidden = true; }, 250);
    }
  };
  const start = () => {
    hide(true);
    showTimer = setTimeout(() => {
      loader.classList.remove('is-leaving');
      loader.hidden = false;
      safetyTimer = setTimeout(() => hide(), 6000);
    }, 220);
  };
  if (document.readyState !== 'complete' && !document.querySelector('.coming-soon[data-ink-reveal]')) start();
  document.addEventListener('brand:reveal-ready', () => {
    if (reduced.matches) return;
    hide(true);
    loader.classList.remove('is-leaving');
    loader.hidden = false;
    hideTimer = setTimeout(() => hide(), 2800);
  });
  window.addEventListener('load', () => hide(), {once:true});
  window.addEventListener('pageshow', () => hide(true));
  window.addEventListener('pagehide', () => hide(true));
  document.addEventListener('visibilitychange', () => { if (document.hidden) hide(true); });
  document.addEventListener('click', event => {
    const link = event.target.closest?.('a[href]');
    if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || link.hasAttribute('download') || link.target && link.target !== '_self') return;
    const url = new URL(link.href, location.href);
    if (url.origin !== location.origin || url.protocol !== location.protocol || url.pathname === location.pathname && url.search === location.search || url.pathname.startsWith('/checkout') || url.pathname.startsWith('/checkouts/')) return;
    start();
  });
}

// Start the complete logo reveal only after the page and its visual assets are ready.
function prepareInkReveal(section) {
  if (section.dataset.inkPrepared) return;
  section.dataset.inkPrepared = 'true';
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (reduced.matches) return;
  section.classList.add('is-ink-pending');
  let started = false;
  const reveal = () => {
    if (started) return;
    started = true;
    clearTimeout(safety);
    requestAnimationFrame(() => requestAnimationFrame(() => {
      section.classList.remove('is-ink-pending');
      section.classList.add('is-ink-ready');
      playLogoReveal(section);
      section.dispatchEvent(new CustomEvent('brand:reveal-ready', {bubbles:true}));
    }));
  };
  const safety = setTimeout(() => {
    started = true;
    section.classList.remove('is-ink-pending');
  }, 8000);
  const pageReady = document.readyState === 'complete' ? Promise.resolve() : new Promise(resolve => window.addEventListener('load', resolve, {once:true}));
  const fontsReady = document.fonts?.ready || Promise.resolve();
  const image = new Image();
  const source = section.querySelector('.brand-logo image')?.getAttribute('href');
  const logoReady = source ? new Promise(resolve => {
    image.onload = () => { if (image.decode) image.decode().catch(() => {}).then(resolve); else resolve(); };
    image.onerror = resolve;
    image.src = source;
  }) : Promise.resolve();
  Promise.all([pageReady, fontsReady, logoReady]).then(reveal).catch(reveal);
}
document.querySelectorAll('.coming-soon[data-ink-reveal]').forEach(prepareInkReveal);
document.addEventListener('shopify:section:load', event => {
  event.target.querySelectorAll('.coming-soon[data-ink-reveal]').forEach(prepareInkReveal);
});

async function playLogoReveal(section) {
  section._stopSandLogo?.();
  section._sandToken=Symbol();
  const request=Symbol();section._revealRequest=request;
  const logo=section.querySelector('.brand-logo');
  section.classList.remove('is-ink-animation');
  if(matchMedia('(prefers-reduced-motion: reduce)').matches){logo.style.removeProperty('opacity');return;}
  const style=section.dataset.logoAnimation || 'sand-smooth';
  if(style==='ink'){
    logo.style.removeProperty('opacity');void logo.getBoundingClientRect();section.classList.add('is-ink-animation');return;
  }
  logo.style.opacity='0';
  try{
    const module=await import(style==='paintbrush'?'./paintbrush-logo.js':style==='sand-original'?'./sand-logo-original.js':'./sand-logo.js');
    if(section._revealRequest===request)await (style==='paintbrush'?module.animatePaintbrushLogo:module.animateSandLogo)(section);
  }catch{logo.style.removeProperty('opacity');}
}
document.addEventListener('brand:replay', event => {
  const section=event.target.closest('.coming-soon');
  if(section)playLogoReveal(section);
});
